<template>
  <div>
    <Header header-text="Professional Experience"></Header>
    <div class="blurb-container">
      <h1 class="blurb-title">DevOps Engineer/SRE, DICE Group @ Jefferson</h1>
      <div class="blurb-decoration-bar"></div>
      <div>
        <div class="blurb-content">
          <ul>
            <li>Maintain and build cloud architecture (GCP and AWS) and ensure best practices are being followed</li>
            <li>Develop ETL processes and maintain legacy APIs and applications</li>
            <li>Design architecture for custom applications</li>
            <li>Develop monitoring, alerting, and graphing solutions for existing infrastructure and custom applications</li>
            <li>Regularly perform OS and application updates</li>
            <li>Implement CI/CD pipelines</li>
            <li>Act as point of contact for Linux and Docker troubleshooting</li>
            <li>3d Model and print prototypes</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="blurb-container">
      <h1 class="blurb-title">Lead Mobile Device Management / System Analyst, Independence Blue Cross</h1>
      <div class="blurb-decoration-bar"></div>
        <div>
          <div class="blurb-content">
            <ul>
              <li>Maintain and update scripts that automate account creation and termination (Powershell, AD, Exchange, ServiceNow)</li>
              <li>Develop scripts to automate routine access provisioning tasks</li>
              <li>Resolve elevated system and application access issues</li>
              <li>Design dashboards for senior management to view automation results at a glance (IIS, Tableau, HTML, CSS, Javascript)</li>
              <li>Assist with mass data collection, organization, and end user support for bi-annual audit process</li>
              <li>Develop and maintain MDM and Apple DEP policies and procedures (MaaS360)</li>
              <li>Train users and team members on mobile devices, policies, and conferencing solutions</li>
              <li>Overhauled wireless provider accounts to substantially lower financial cost and increase wireless features</li>
              <li>Maintain mobile IT assets to inventory and apply correct charges (HP Asset Manager)</li>
              <li>Develop and employ strategies for large-scale mobile device deployment and utilization projects</li>
              <li>Troubleshoot mobile device hardware and software issues for all iOS and Android devices</li>
              <li>Build and deploy laptops and desktops via System Center Configuration Manager (SCCM)</li>
            </ul>
          </div>
        </div>
    </div>

    <div class="blurb-container">
      <h1 class="blurb-title">Lead Social Media / Internet Investigator, Social Detection</h1>
      <div class="blurb-decoration-bar"></div>
        <div>
          <div class="blurb-content">
            <ul>
              <li>Conduct internet based investigations for use primarily by lawyers and private investigators</li>
              <li>Assist in the training and management of new Social Media Internet Analysts</li>
              <li>Implement design changes to report templates in Microsoft Office and Adobe Acrobat</li>
              <li>Modify existing website using HTML and CSS</li>
              <li>Construct logos, icons, and banners for use on the website and reports using Adobe Photoshop and Adobe Illustrator</li>
            </ul>
          </div>
        </div>
    </div>

    <div class="blurb-container">
      <h1 class="blurb-title">Customer Support Analyst / Mobility Subject Matter Expert, PPG</h1>
      <div class="blurb-decoration-bar"></div>
        <div>
          <div class="blurb-content">
            <ul>
              <li>Served as first support contact for any technical issues for 30k+ PPG employees, supporting various complex systems such as: SAP, Oracle 11i and R12, Sharepoint, Concur, Direct Access, Juniper Network Connect, Symantec Endpoint Protection, Avaya phone systems, Blackberry Enterprise software, Active Directory, Citrix, Windows Vista, 7, and 8 operating systems, Microsoft Office 2010 and 2013, and iOS, Android, Blackberry, and Windows Phone mobile operating systems</li>
              <li>Effectively pinpointed and resolved dynamic issues remotely using Windows Remote Assistance, Microsoft Lync, Juniper Netmeeting, or LogMeIn support software</li>
              <li>Oversaw, monitored, and audited site networks using PRTG Network Monitor</li>
              <li>Collaborated regularly with internal mobility team to devise new best practice solutions for common issues with mobile phones and telecommuting intranet access</li>
              <li>Provide extensive mobility support for 30 Customer Support Analysts</li>
              <li>Worked with tier 3 teams to create solutions for recurring or critical technical issues</li>
              <li>Monitor the service desk e-mail account for several international and domestic locations, including the United States, Canada, Australia, New Zealand, and Southeast Asia</li>
              <li>Responsible for tracking and documenting all issues using VMWare ticketing software (Infra)</li>
            </ul>
          </div>
        </div>
    </div>  
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
    Header
  }
}
</script>
<style>
ul {
  text-align: left;
}
</style>